import { ShieldAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { useQuota } from '@/shared/hooks/useQuota'
import { formatIsoDateDisplay } from '@/shared/lib/datetime'
import { toneSoftClass } from './tone'

export function QuotaBadge({
  resourceType,
  resourceId,
  className,
}: {
  resourceType: string
  resourceId?: string
  className?: string
}) {
  const { t } = useTranslation()
  const quota = useQuota(resourceType, resourceId)

  if (quota.isPending || quota.isError || quota.data === undefined) {
    return null
  }

  const { allowed, remaining, resetsAt } = quota.data

  if (allowed && remaining > 2) {
    return null
  }

  const label = allowed
    ? t('shared.quota.remaining', { count: remaining })
    : resetsAt
      ? t('shared.quota.exhausted_until', { date: formatIsoDateDisplay(resetsAt.toISOString()) })
      : t('shared.quota.exhausted')

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-pill border px-2.5 py-0.5 text-xs font-medium',
        allowed ? toneSoftClass.warn : toneSoftClass.err,
        className,
      )}
      aria-label={label}
    >
      <ShieldAlert className="size-3.5 shrink-0" aria-hidden />
      <span>{label}</span>
    </span>
  )
}
